import { CLOUDFLARE_SITEKEY } from "@/Constants/ApiConstants";
import { forwardRef, useImperativeHandle, useState } from "react";
import Turnstile from "react-turnstile";
import styled from "./styled.module.scss";

interface CaptchaWidgetProps {
  onVerify: (token: string) => void;
}

export interface CaptchaWidgetRef {
  reset: () => void;
}

const CaptchaWidget = forwardRef<CaptchaWidgetRef, CaptchaWidgetProps>(
  ({ onVerify }, ref) => {
    const [instanceKey, setInstanceKey] = useState(0);

    const handleVerify = (token: string) => {
      onVerify?.(token);
    };

    useImperativeHandle(ref, () => ({
      reset() {
        setInstanceKey((k) => k + 1);
      },
    }));

    return (
      <div className={styled.widget_container}>
        <Turnstile
          key={instanceKey}
          sitekey={CLOUDFLARE_SITEKEY}
          onVerify={handleVerify}
          refreshExpired="auto"
        />
      </div>
    );
  }
);

export default CaptchaWidget;
